import React from 'react';
import ReactDOM from 'react-dom/client';
import 'antd/dist/reset.css';
import './index.css';
import { ConfigProvider } from 'antd';
import MyApp from './MyApp';
import { AuthProvider } from 'contexts/authContext';
import { OrgProvider } from 'contexts/orgContext';
import { ThemeProvider, useTheme } from 'contexts/themeContext';
import { registerStaleChunkReload } from 'utils/reloadOnStaleChunk';

registerStaleChunkReload();

function ThemedApp() {
  const { antdTheme } = useTheme();
  return (
    <ConfigProvider theme={antdTheme}>
      <AuthProvider>
        <OrgProvider>
          <MyApp />
        </OrgProvider>
      </AuthProvider>
    </ConfigProvider>
  );
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <ThemedApp />
    </ThemeProvider>
  </React.StrictMode>
);
